import { styled } from '@mui/material';

export const NftSectionContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  margin: '48px auto',
  maxWidth: 1050,
}));
